import { Injectable } from '@angular/core';
import { merge, Observable, of, fromEvent, BehaviorSubject } from 'rxjs';
import { mapTo } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {
  private _connection = new BehaviorSubject<boolean>(true);

  constructor() {
    merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(mapTo(true)),
      fromEvent(window, 'offline').pipe(mapTo(false))
    ).subscribe(value => this._connection.next(value));
  }

  get connection(): boolean {
    return this._connection.value;
  }

  get connection$(): Observable<boolean> {
    return this._connection.asObservable();
  }

  /*  subscribeConnection$(): Observable<boolean> {
    return merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(mapTo(true)),
      fromEvent(window, 'offline').pipe(mapTo(false))
    );
  }*/
}
